import React from "react";
import { Breakdown } from "./Breakdown";
import { Atol, Disclaimers } from "./banners";
import { Stack } from "@bookingcom/bui-react";
import {
  useUnifiedPriceBreakdownFarePriceController,
  type UnifiedPriceBreakdownFarePriceControllerProps
} from "./useUnifiedPriceBreakdown.FarePrice.controller";
import useEvents from "hooks/useEvents";

export type UnifiedPriceBreakdownFarePriceProps = UnifiedPriceBreakdownFarePriceControllerProps;

export function UnifiedPriceBreakdownFarePrice(props: UnifiedPriceBreakdownFarePriceProps) {
  const {
    isHungaryDepartingRyanAir,
    disclaimers,
    isWithDiscount,
    unifiedPriceBreakdown,
    routeName,
    expandedByDefault
  } = useUnifiedPriceBreakdownFarePriceController(props);
  const { grumble } = useEvents();

  if (!unifiedPriceBreakdown) {
    grumble("unifiedPriceBreakdown object unavailable", { controller: "FarePrice", routeName });
    return null;
  }

  return (
    <Stack gap={4}>
      <Breakdown
        {...unifiedPriceBreakdown}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
        isWithDiscount={isWithDiscount} // flights_web_unified_price_breakdown
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
    </Stack>
  );
}
